import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format a 10-digit Australian landline as (0X) XXXX XXXX or mobile as XXXX XXX XXX. */
export function formatPhone(raw: string = '') {
  const digits = raw.replace(/\D/g, '')
  if (digits.length !== 10) return raw
  if (digits.startsWith('04')) {
    return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)} ${digits.slice(6)}`
}

/** AUD money formatter shared between server and client modules. */
export function formatPrice(value: number): string {
  return `$${value.toLocaleString('en-AU')}`
}
